module.exports = __webpack_public_path__ + "img/2.604f12ea.png";